import { QuestionsModule } from "pages/Cash/components/QuestionsModule/QuestionsModule";

const HelpAndQuestions = props => {
  return <QuestionsModule {...props}/>
}

export default HelpAndQuestions;